import { isApiError } from '@wix/da-http-client';
import { requestPuppyFromExtension } from '../../utils/requestPuppyFromExtension';
export async function fetchDeviation(editor, deviationLookup) {
    const result = await requestPuppyFromExtension(editor, {
        method: 'get',
        url: `/deviation/fetch`,
        params: {
            deviationid: deviationLookup.deviationid,
            type: deviationLookup.type,
            username: deviationLookup.username
        }
    }, ()=>{
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line global-require
            const { deviationsByType } = require('@wix/da-sample-data');
            return deviationsByType.image[1];
        }
    });
    if (isApiError(result)) {
        return result;
    }
    return result;
}

//# sourceMappingURL=fetchDeviation.js.map